import axios from "../axios";
import api from "../api";

export const state = {
  data: {},
}

export const mutations = {
  SET_SCRIPT_GENERATOR_STATE (state, {key, value}) {
    state[key] = value
  }
}

export const actions = {
  async get_script_generator_prompts ({ commit }) {
    try {
      commit('SET_REQ_STATUS', 'fetching')
      const { data } = await axios.get(api.scriptGenerator)
      commit('SET_SCRIPT_GENERATOR_STATE', { key: 'data', value: data })
      commit('SET_REQ_STATUS', 'idle')
    } catch (err) {
      console.log(err)
      commit('SET_REQ_STATUS', 'failed')
    }
  },
  async update_script_generator_prompts ({ state, commit }) {
    try {
     commit('SET_REQ_STATUS', 'sending')
     await axios.put(api.scriptGenerator, {
      ...state.data,
      _id: "utils"
     })
     commit('SET_REQ_STATUS', 'idle')
    } catch (err) {
      console.log(err)
      commit('SET_REQ_STATUS', 'failed')
    }
  }
}